import Nav from "./nav"
import TableOfContents from "./table-of-contents-nav"
// import Animation from "./animation"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    TableOfContents(jQuery)
    // Animation(jQuery)
})
